import React, { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

export default function Map({ events, zoom, height, centerEvent }) {
    const mapContainerRef = useRef();
    const mapRef = useRef();

    mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
    const [lng] = useState(events[0].venues[0] ? events[0].venues[0].gps_longitude : -122.3328);
    const [lat] = useState(events[0].venues[0] ? events[0].venues[0].gps_latitude : 47.6061); 
    const [zoomLevel] = useState(zoom);

  useEffect(() => {
    mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
    mapRef.current = new mapboxgl.Map({
      container: mapContainerRef.current,
      center: [lng, lat], 
      zoom: zoomLevel, 
      style: 'mapbox://styles/mapbox/light-v11',
    },[]);

    mapRef.current.addControl(new mapboxgl.NavigationControl());

    events.forEach((event) => {
        new mapboxgl.Marker({color: "#9D2045"})
        .setLngLat([event.venues[0].gps_longitude, event.venues[0].gps_latitude])
        .setPopup(
          new mapboxgl.Popup({ maxWidth:'none', closeOnMove:true })
            .setHTML(
              `<a href=${`/event/${event.id}`} style="color: #000000;"><h6>${event.venues[0].name}</h6></a>
                <p>${event.venues[0].address_street} ${event.venues[0].address_city} ${event.venues[0].address_state}</p>`
            )
        )
        .addTo(mapRef.current)
    });
  });

  return (
    <div
      style={{ height: height, borderRadius: 5 }}
      ref={mapContainerRef}
      className="map-container"
      id="map"
    />
  );
};